import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import SpeakersFeatured from './components/SpeakersFeatured';
import { fetchSpeakers } from './actions/speakersActions';

export const mapStateToProps = state => ({
    speakers: state.speakers.speakers,
    route: state.router.location.pathname,
    fetchingSpeakers: state.speakers.fetchingSpeakers
});

export const mapActionCreators = { fetchSpeakers, pushAction };

export default connect(
    mapStateToProps,
    mapActionCreators
)(SpeakersFeatured);
